<template>
  <div>
    <b-modal
      v-model="showTimeout"
      id="session-timeout"
      modal-class="failed-screening"
      centered
      no-close-on-esc
      no-close-on-backdrop
      @shown="countDownTimer"
      hide-header
      hide-footer
    >
      <div class="failed-screening-icon">
        <img
          src="../assets/warning-icon.png"
          class="icon"
        >
      </div>

      <p class="my-4 text-center">
        Your session will timeout in {{ secondsToWait }} seconds!
      </p>

      <b-button
        variant="green"
        class="failed-screening-option"
      >
        Continue Session &raquo;
      </b-button>

      <template v-slot:modal-header-close>
        &nbsp;
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data () {
    return {
      show: true,
      secondsToWait: 60,
      modalTimeoutPtr: '',
      logoutTimeoutPtr: ''
    }
  },
  computed: {
    showTimeout () {
      return (this.isAppIdle && this.isOnline)
    }
  },
  watch: {
    isAppIdle (newValue, oldValue) {
      if (this.isOnline && !this.showSendOfflineFormsPrompt && newValue === true) {
        const showModalFor = this.secondsToWait * 1000
        const isTimeOut = true
        this.logoutTimeoutPtr = setTimeout(() => {
          this.logout(isTimeOut)
        }, showModalFor)
      } else {
        clearTimeout(this.logoutTimeoutPtr)
        clearTimeout(this.modalTimeoutPtr)
        this.secondsToWait = 60
      }
    }
  },
  methods: {
    ...mapActions({
      logout: 'authentication/logout'
    }),
    countDownTimer () {
      if (this.secondsToWait > 0) {
        this.modalTimeoutPtr = setTimeout(() => {
          this.secondsToWait -= 1
          this.countDownTimer()
        }, 1000)
      }
    }
  }
}
</script>

<style scoped>
  .slide-enter-active {
      transition: all .5s ease;
  }
  .slide-leave-active {
      transition: all .5s ease;
  }
  .slide-enter, .slide-leave-to {
      transform: translateY(0);
      opacity: 0;
  }
</style>
